<template>
  <BaseTab v-bind="attrs"
           v-model="selectedTabIndex"
           v-on="$listeners"
           :initSelectedTabIndex="initSelectedTabIndex"
           :tabs="tabs"
           :tabsRight="false" />
</template>

<script>
  import BaseTab from '@base/base-tab'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TabPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'switch-tab',
    },
    components: {
      BaseTab,
    },
    props: {
      vmodelValue: { type: Number },
      initSelectedTabIndex: { type: Number, required: false, default: 0 },
      tabs: { type: Array, required: false, default: () => [] },
    },
    data: function () {
      return {
        attrs: {
          boxSizing: 'border-box',
          height: '21px',
          tabStyle: {
            boxSizing: 'border-box',
            borderWidth: '0 0 1px 0',
            cursor: { '': 'pointer', disabled: 'default' },
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.lg,
            height: '21px',
            lineHeight: '17px',
            margin: `0 ${Layout.space.lg} 0 0`,
            padding: '0 0 4px 0',
          },
        },
        selectedTabIndex: 0,
      };
    },
    created: function () {
      this.attrs.tabStyle = {
        ...this.attrs.tabStyle,
        border: {
          '': 'solid transparent',
          selected: `solid ${this.color.dark0()}`,
        },
        color: {
          '': this.color.dark3(),
          hover: this.color.dark2(),
          active: this.color.dark2(),
          disabled: this.color.dark4(),
          selected: this.color.dark1(),
        },
      };
      this.attrs = {
        ...this.attrs,
        border: `solid ${this.color.dark5()}`,
        borderWidth: '0 0 1px 0',
        ...this.$attrs,
      };

      this.selectedTabIndex = this.vmodelValue;
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.selectedTabIndex = newVal;
      },
    },
  };
</script>
